import React from 'react';
import { HeaderTooltip } from '../HeaderTooltip/HeaderTooltip';

export const ListingViewsTooltip = () => (
  <HeaderTooltip title="Listing views" message="Views are counted each time your listing is selected and opened." />
);

export const ImpressionsTooltip = () => (
  <HeaderTooltip
    title="Impressions"
    message="Total impressions are views of your listing on the Zillow search results page, in a Zillow email, or in a Boost Ad. Impressions are counted toward your total regardless of whether the listing is selected and opened."
  />
);

export const LeadsTooltip = () => (
  <HeaderTooltip title="Leads" message="These are people who reached out to contact you by phone or email." />
);

export const DaysOnMarketTooltip = () => (
  <HeaderTooltip title="Days on market" message="This is how many days your listing has been live on Zillow." />
);

export const WebsiteReferralsTooltip = () => (
  <HeaderTooltip
    title="Listing Web Referrals"
    message="These are people who visited your personal website by following a link from Zillow."
  />
);

export const AdClicksTooltip = () => (
  <HeaderTooltip
    title="Ad Clicks"
    message="These are people who visited clicked on a zillow ad promoting your listing."
  />
);

export const ContactRateTooltip = () => (
  <HeaderTooltip
    title="Contact Rate"
    message="Of all the people who viewed your listing, this is the percentage who contacted you."
  />
);
